module.exports = __webpack_public_path__ + "img/picture_kmskcspvip05@2x.38c9b7cb.png";